<template>
    <div class="page-table-layout" data-testid="financialclose-project-trialbalance">
        <v-card class="all-width flex-card shadow-off" loader-height="2" :loading="loading" :disabled="loading" data-testid="financialclose-project-trialbalance__main-card">
            <v-card-text class="page-table-layout__body" data-testid="financialclose-project-trialbalance__main-card-text">
                    <div class="d-flex align-center justify-space-between" v-if="!loading || metadata._id" data-testid="financialclose-project-trialbalance__headerbar">
                        <div class="d-flex flex-column align-start justify-start mb-2" data-testid="financialclose-project-trialbalance__breadcrumbbar">
                            <div class="d-flex align-baseline" data-testid="financialclose-project-trialbalance__titlebar">
                                <h3 class="font-weight-semibold black--text noTransform" data-testid="financialclose-project-trialbalance__title">Trial Balance</h3>
                                <v-tooltip bottom content-class="tooltip-bottom">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" height="24" width="24" v-on="on" class="shadow-off ml-1" icon @click="refreshData()" data-testid="financialclose-project-trialbalance__refresh-btn">
                                            <v-icon size="" data-testid="financialclose-project-trialbalance__refresh-icon">mdi-refresh</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Refresh</span>
                                </v-tooltip>
                                <TasklistLoadProgress
                                    v-if="tbHeaderLoadProgress"
                                    class="ml-2"
                                    test-id="trialbalance__load-progress"
                                    :loaded="tbHeaderLoadProgress.loaded"
                                    :total="tbHeaderLoadProgress.total"
                                    :status="tbHeaderLoadProgress.status"
                                    :error="tbHeaderLoadProgress.error || ''"
                                    :retrying="tbHeaderLoadProgress.retrying"
                                    :messages="$options.TB_LOAD_MESSAGES"
                                    @retry="retryTbLoad"
                                />
                            </div>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="d-flex flex-column" data-testid="financialclose-project-trialbalance__actionbar">
                            <div data-testid="financialclose-project-trialbalance__actionbar-btns">
                                <v-btn color="" class="mr-1 secondaryBtn px-4 py-1"  @click="syncERP()" v-if="$store.state.erpEnabled.tbErpEnabled" data-testid="financialclose-project-trialbalance__sync-btn">
                                    <v-icon class="pr-2" data-testid="financialclose-project-trialbalance__sync-icon">mdi-file-sync-outline</v-icon>
                                    <p class="ma-0 pa-0" data-testid="financialclose-project-trialbalance__sync-label"> {{'Update from ERP'}}</p>
                                </v-btn>
                                <v-tooltip v-if="metadata.managerlist && metadata.managerlist.indexOf(userid) > -1" bottom content-class="tooltip-bottom" :disabled="!uploadInProgress">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <v-btn color="primary" class="white--text radius-mini ml-2" :disabled="uploadInProgress" :loading="uploadInProgress" @click="openBulkUpload" data-testid="financialclose-project-trialbalance__bulkupload-btn">
                                                <template v-slot:loader>
                                                    <v-progress-circular indeterminate size="20" width="2" color="white" />
                                                </template>
                                                <v-icon class="mr-1" data-testid="financialclose-project-trialbalance__bulkupload-icon">mdi-upload-multiple</v-icon>
                                                <p data-testid="financialclose-project-trialbalance__bulkupload-label">Bulk Upload</p>
                                            </v-btn>
                                        </span>
                                    </template>
                                    <span>{{ $options.TB_UPLOAD_MESSAGES.BUTTON_IN_PROGRESS }}</span>
                                </v-tooltip>
                            </div>
                            <p v-if="(lastRunData[0] || {}).lastupdated" class="ma-0 mt-4" data-testid="financialclose-project-trialbalance__lastsync">
                                Last sync:
                                {{ $nova.formatDateTime(new Date(lastRunData[0].lastupdated).getTime()) }}
                            </p>
                        </div>
                    </div>
                    <div v-if="loading && !metadata._id" data-testid="financialclose-project-trialbalance__loading">
                        <v-skeleton-loader type="table-heading, list-item-two-line, article, article" data-testid="financialclose-project-trialbalance__loading-skeleton"></v-skeleton-loader>
                    </div>
                    <!-- Closing Balance Bar & Actions Toolbar -->
                    <div v-if="metadata._id && tb.length > 0" class="all-width d-flex align-center justify-space-between mb-2" data-testid="financialclose-project-trialbalance__closingbalancebar">
                        <div v-if="!metadata.tbInitialized" class="d-flex align-center warning--text" data-testid="financialclose-project-trialbalance__tb-warning">
                            <v-icon color="warning" small class="mr-1">mdi-alert</v-icon>
                            <span>Trial balance (TB) not yet uploaded; hence values are showing zero in the TB</span>
                        </div>
                        <div v-else></div>
                        <div class="d-flex align-center">
                        <div class="d-flex align-center black--text mr-3" v-if="Math.round(closingbalancetotal) !== 0" data-testid="financialclose-project-trialbalance__closingbalancebar-diff">
                            <span class="mr-2">Closing Balance Difference :</span>
                            <span class="red--text text-decoration-underline font-size-md" data-testid="financialclose-project-trialbalance__closingbalancebar-diff-value">{{ $nova.formatNumber(closingbalancetotal) }}</span>
                        </div>
                        <div class="d-flex align-center justify-center" data-testid="financialclose-project-trialbalance__actionbar-table">
                                        <!-- /* TODO: Temporarily set to display: none; for current requirements. Will be updated in future versions. */ -->
                                    <div class="d-none">
                                        <v-slide-x-reverse-transition>
                                            <lb-string v-if="toggleSearchBtn" v-model="searchQuery" placeholder="Search.." hidedetails label="" :isClearable="false" data-testid="financialclose-project-trialbalance__search-input" />
                                        </v-slide-x-reverse-transition>
                                        <v-tooltip bottom content-class="tooltip-bottom mt-2">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" icon @click="toggleSearch" data-testid="financialclose-project-trialbalance__search-btn">
                                                    <v-icon data-testid="financialclose-project-trialbalance__search-icon">mdi-magnify</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Search</span>
                                        </v-tooltip>
                                    </div>

                                    <!-- Clear Filter Button - First item before CustomizeColumnMenu -->
                                    <v-btn
                                        v-if="hasActiveTableFilter"
                                        text
                                        class="ml-2 mr-2 data-table-action__clear-filter-btn"
                                        @click="clearTableFilter()"
                                        data-testid="financialclose-project-trialbalance__toolbar-clear-filter-btn"
                                    >
                                        <span>Clear Filter</span>
                                    </v-btn>
                                    <activity-log 
                                        :resource-id="metadata._id" 
                                        data-testid="financialclose-project-trialbalance__action-activitylog-btn" 
                                        row-description="Trial Balance Actions"
                                        :type="$options.ACTIVITY_LOG_TYPES.TRIAL_BALANCE"
                                        />

                                    <v-tooltip bottom content-class="tooltip-bottom">
                                            <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                            <v-btn icon class="ml-1" :disabled="!tbLoadComplete" @click="downloadExcel" data-testid="financialclose-project-trialbalance__download-btn">
                                                                    <v-icon data-testid="financialclose-project-trialbalance__download-icon">mdi-download</v-icon>
                                                            </v-btn>
                                                    </span>
                                            </template>
                                            <span>{{ tbLoadComplete ? 'Download TB' : $options.TB_LOAD_MESSAGES.ACTIONS_LOCKED }}</span>
                                    </v-tooltip>

                                    <!-- CustomizeColumnMenu component - Apply only -->
                                    <CustomizeColumnMenu
                                      v-model="customizeMenuOpen"
                                      :headers="headers"
                                      color="caccounting"
                                      :show-save-button="false"
                                      :show-apply-button="true"
                                      data-testid-prefix="financialclose-project-trialbalance"
                                      @apply="handleApplyColumns"
                                    />
                                </div>
                        </div>
                    </div>

                    <!-- Table Section - fills remaining space -->
                    <div v-if="metadata._id && tb.length > 0" class="flex-fill-table">
                        <lb-datatableaction ref="dataTableAction" v-if="formateDataCopy.length > 0" :headers="headers"
                                    :tabledata="formateDataCopy" :itemsperpage="itemsPerPage"
                                    :displayedRowCount="paginatedFilteredItems.length"
                                    :filter-options-data="columnFilterSourceData"
                                    :searchterm="search" :bulkActions="false" @filter-item="filterPart" @filter-active-change="onFilterActiveChange" @refresh="refreshData()"
                                    data-testid="financialclose-project-trialbalance__datatable">
                                <template v-slot:tbody>
                                    <tr v-for="item in paginatedFilteredItems" :key="item._id" class=" " data-testid="financialclose-project-trialbalance__row">
                                        <template v-for="header in headers">
                                            <td v-if="header.visible && header.value !== 'action'"
                                                :key="header.value" class="px-4 single-line"
                                                :class="{ 'description-header': header.value === 'description' }" data-testid="financialclose-project-trialbalance__cell">
                                                <div v-if="header.value === 'location'" class="d-flex align-center" data-testid="financialclose-project-trialbalance__cell-location">
                                                    <span v-if="(item.location || []).length > 0"
                                                        class="d-inline-flex width-fit pa-2 caccounting-background radius-mini caccounting--text mr-2" data-testid="financialclose-project-trialbalance__cell-location-main">{{ item.location[0] }}</span>
                                                    <v-tooltip top content-class="tooltip-top">
                                                        <template v-slot:activator="{ on }">
                                                            <span v-if="(item.location || []).length > 1" v-on="on"
                                                                class="d-inline-flex width-fit radius-mini caccounting-background font-size-xm caccounting--text pa-2" data-testid="financialclose-project-trialbalance__cell-location-more">+{{ item.location.length - 1 }}</span>
                                                        </template>
                                                        <div v-for="(loc, index) in item.location " :key="index" data-testid="financialclose-project-trialbalance__cell-location-tooltip-item">
                                                            <span>{{ loc }}</span>
                                                        </div>
                                                    </v-tooltip>
                                                </div>
                                                <div v-else-if="header.value === 'reference_detail'" class="d-flex align-center" data-testid="financialclose-project-trialbalance__cell-reference">
                                                    <span v-if="item.reference_detail && item.reference_detail[0] && item.reference_detail[0].ref"
                                                        class="d-inline-flex width-fit pa-2 caccounting-background radius-mini caccounting--text mr-2 cursor-pointer"
                                                        @click="openTaskDetail(item.reference_detail)" data-testid="financialclose-project-trialbalance__cell-reference-main">{{ item.reference_detail[0].ref }}</span>
                                                    <v-tooltip top content-class="tooltip-top">
                                                        <template v-slot:activator="{ on }">
                                                            <span v-if="(item.reference_detail || []).length > 1" v-on="on"
                                                                class="d-inline-flex width-fit radius-mini caccounting-background font-size-xm caccounting--text pa-2 cursor-pointer" data-testid="financialclose-project-trialbalance__cell-reference-more">+{{ item.reference_detail.length - 1 }}</span>
                                                        </template>
                                                        <div v-for="(refItem, index) in (item.reference_detail || []).slice(1) " :key="index" data-testid="financialclose-project-trialbalance__cell-reference-tooltip-item">
                                                            <span>{{ refItem.ref }}</span>
                                                        </div>
                                                    </v-tooltip>
                                                </div>
                                                <div class="" v-else-if="header.value === 'created_at'" data-testid="financialclose-project-trialbalance__cell-createdat">
                                                    {{ $nova.formatDate(item.created_at) }}
                                                </div>
                                                <div class="" v-else-if="header.value === 'updated_at'" data-testid="financialclose-project-trialbalance__cell-updatedat">
                                                    {{ $nova.formatDate(item.updated_at) }}
                                                </div>
                                                <span v-else data-testid="financialclose-project-trialbalance__cell-value"> {{ item[header.value] }}</span>
                                            </td>
                                        </template>
                                        <td class=" px-3 single-line border-right border-left action-data" data-testid="financialclose-project-trialbalance__actions">
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }" > 
                                                    <v-btn icon v-bind="attrs"  v-on="on" @click="addEditForm(item)" data-testid="financialclose-project-trialbalance__action-edit-btn">
                                                        <v-icon data-testid="financialclose-project-trialbalance__action-edit-icon">mdi-pencil-outline</v-icon></v-btn>
                                                </template>
                                                <span>Edit</span>
                                            </v-tooltip>
                                            <activity-log 
                                                :resource-id="item._id" 
                                                data-testid="financialclose-project-trialbalance__action-activitylog-btn" 
                                                :row-description="item.name"
                                            />
                                        </td>
                                    </tr>
                                </template>
                                </lb-datatableaction>

                                <div class="d-flex align-center justify-center" v-else data-testid="financialclose-project-trialbalance__empty-state">
                                    NO DATA
                                </div>
                    </div>

                    <!-- Fallback Section - when no data exists -->
                    <div v-if="tbLoadComplete && metadata._id && tb.length === 0" class="pa-0" data-testid="financialclose-project-trialbalance__fallback-section">
                                <div class="d-flex align-center pa-2" data-testid="financialclose-project-trialbalance__fallback-actionbar">
                                    <!-- <span class="mr-4" v-if="metadata.managerlist.indexOf(userid) > -1">Trial
                                        Balance</span>
                                    <v-btn color="primary" class="mr-1"
                                        @click="tbuploaddata = []; tbfile = null; tbdialog = true"
                                        v-if="metadata.managerlist.indexOf(userid) > -1">
                                        <v-icon class="mr-1">mdi-upload-multiple</v-icon>
                                        <span>Bulk Upload</span>
                                    </v-btn> -->
                                    <!-- <lb-drawer v-model="tbdialog" :width="(tbuploaddata.length > 0) ? '' : '400'"
                                        heading="Bulk TrialBalance Upload" :loading="loading">
                                        <template v-slot:body>
                                            <div>
                                                <div class="text-center mb-1">Upload the bulk upload trialbalance
                                                    template here.</div>
                                                <div class="d-flex align-center justify-center">
                                                    <lb-file v-model="tbfile" label="" class="py-0 my-0"
                                                        :loading="fileprocessing['__tb'] === 1" :drag="false"
                                                        hidedetails @change="readTBFile('__tb')" :displayname="false"
                                                        accept=".xlsx,.xls,.xlsm,.xlsb"
                                                        v-if="metadata.managerlist.indexOf(userid) > -1" />
                                                    <v-btn v-if="metadata.managerlist.indexOf(userid) > -1"
                                                        color="primary" class="ml-2"
                                                        @click="$nova.downloadFile('', {}, '/v2/financialclose/analysis/getuploadtbtemplate')">Download
                                                        Template</v-btn>
                                                </div>
                                            </div>
                                            <div v-if="tbuploaddata.length > 0" class="mt-3">
                                                <v-simple-table dense class="">
                                                    <template v-slot:default>
                                                        <thead class="tableHeaderBg">
                                                            <th class="text-left">GL Code</th>
                                                            <th class="text-right">Opening Amount</th>
                                                            <th class="text-right">Transaction</th>
                                                            <th class="text-right">Audit Entries</th>
                                                            <th class="text-right">Closing Amount</th>
                                                            <th class="text-right">Location</th>
                                                        </thead>
                                                        <v-slide-y-transition class="" group tag="tbody"
                                                            style="overflow: hidden !important">
                                                            <tr v-for="(v, k) in tbuploaddata" :key="k" class="">
                                                                <td v-if="((tbdataerror[k] || [])[0] || [])[1] !== ''"
                                                                    class="error--text font-weight-bold">
                                                                    <v-tooltip bottom content-class="tooltip-bottom">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <div v-bind="attrs" v-on="on">
                                                                                {{ (v.data[0] || {}).glcode || "Error"
                                                                                }}
                                                                            </div>
                                                                        </template>
                                                                        <span>{{ ((tbdataerror[k] || [])[0] || [])[1]
                                                                            }}</span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td class="" v-else>{{ (v.data[0] || {}).glcode }}</td>
                                                                <td class="text-right">
                                                                    {{ $nova.formatNumber((v.data[0] ||
                                                                        {}).opening_amount) }}
                                                                </td>
                                                                <td class="text-right">
                                                                    {{ $nova.formatNumber((v.data[0] || {}).transaction)
                                                                    }}
                                                                </td>
                                                                <td class="text-right">
                                                                    {{ $nova.formatNumber((v.data[0] ||
                                                                        {}).audit_entries) }}
                                                                </td>
                                                                <td class="text-right">
                                                                    {{ $nova.formatNumber((v.data[0] ||
                                                                        {}).closing_amount) }}
                                                                </td>
                                                                <td class="text-right">
                                                                    {{ ((v.data[0] || {}).location) }}
                                                                </td>
                                                            </tr>
                                                        </v-slide-y-transition>
                                                    </template>
                                                </v-simple-table>
                                            </div>
                                        </template>
                                        <template v-slot:actions>
                                            <v-spacer></v-spacer>
                                            <div class="ml-2 error--text font-weight-bold" v-if="tberrorflag">
                                                We found few errors. Rectify the same to proceed to upload
                                            </div>
                                            <v-btn class="ml-2" color="primary"
                                                v-else-if="tbuploaddata.length > 0" @click="uploadTBData()">Verify &
                                                Upload</v-btn>
                                        </template>
                                    </lb-drawer> -->

                                    <v-spacer></v-spacer>
                                    <v-chip v-if="tb.length === 0 " color="info" label data-testid="financialclose-project-trialbalance__fallback-chip-pending"><span>Pending</span></v-chip>
                                    <v-chip v-else color="success" label data-testid="financialclose-project-trialbalance__fallback-chip-uploaded"><span>Uploaded</span></v-chip>
                                </div>
                                <v-divider></v-divider>
                    </div>

                </v-card-text>
            </v-card>
           

            <lb-drawer v-model="tasklistdilog" heading="Edit Account Details" :loading="tasklistdilogloading"
                width="600" data-testid="financialclose-project-trialbalance__tasklistdrawer">
                <template v-slot:body>
                    <v-row data-testid="financialclose-project-trialbalance__tasklistdrawer-row">
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-glcode">Account No.</span>
                        </v-col>
                        <v-col cols="9">
                            <span class="caccounting--text caccounting-background pa-1 radius-mini" data-testid="financialclose-project-trialbalance__tasklistdrawer-value-glcode">{{ tasklistitem.glcode }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-name">Account Name</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-name">{{ tasklistitem.name }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-type">Type</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-type">{{ tasklistitem.type }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-location">{{$store.state.LocationHeader || 'Location'}}</span>
                        </v-col>
                        <v-col cols="9">
                            <span class="caccounting--text caccounting-background pa-1 radius-mini" data-testid="financialclose-project-trialbalance__tasklistdrawer-value-location">{{ (tasklistitem.location || [])[0] }}</span>
                        </v-col>

                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-category">Category</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-category">{{ tasklistitem.category }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-subcategory">Sub Category</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-subcategory">{{ tasklistitem.sub_category }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-opening">Opening Amount</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-opening">({{ tasklistitem.opening_amount }})</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-transaction">Transaction</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-transaction">({{ tasklistitem.transaction }})</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-journal">Journal Entries</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-journal">({{ tasklistitem.audit_entries }})</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="grey--text" data-testid="financialclose-project-trialbalance__tasklistdrawer-label-closing">Closing Amount</span>
                        </v-col>
                        <v-col cols="9">
                            <span data-testid="financialclose-project-trialbalance__tasklistdrawer-value-closing">({{ tasklistitem.closing_amount }})</span>
                        </v-col>



                    </v-row>
                    <div class="d-flex align-center justify-end mb-2 mt-2" data-testid="financialclose-project-trialbalance__tasklistdrawer-addtaskbar">
                        <v-btn class="shadow-off"
                            @click="openSelectGlDialog(tasklistitem.reference_detail, tasklistitem.location_id)"
                            text data-testid="financialclose-project-trialbalance__tasklistdrawer-addtask-btn"><v-icon class="mr-1">mdi-plus</v-icon><span>Add Task</span></v-btn>
                    </div>
                    <v-simple-table dense class="simple-table border-on radius-small"
                        v-if="(tasklistitem.reference_detail || []).length > 0" data-testid="financialclose-project-trialbalance__tasklistdrawer-table">
                        <thead class="tableHeaderBg">
                            <tr>
                                <th class="tableHeaderBg" scope="Name" data-testid="financialclose-project-trialbalance__tasklistdrawer-table-header-reference">Reference</th>
                                <th class="tableHeaderBg" scope="columns" data-testid="financialclose-project-trialbalance__tasklistdrawer-table-header-description">Description</th>
                                <th class="tableHeaderBg" scope="category" data-testid="financialclose-project-trialbalance__tasklistdrawer-table-header-category">Category</th>
                                <th class="tableHeaderBg" scope="Action" data-testid="financialclose-project-trialbalance__tasklistdrawer-table-header-remove">Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                v-for="(v, k) in (tasklistitem.reference_detail || [])" 
                                :key="k" 
                                data-testid="financialclose-project-trialbalance__tasklistdrawer-table-row"
                            >
                                <td data-testid="financialclose-project-trialbalance__tasklistdrawer-table-cell-reference">{{ v.ref }}</td>
                                <td data-testid="financialclose-project-trialbalance__tasklistdrawer-table-cell-description">{{ v.description }}</td>
                                <td data-testid="financialclose-project-trialbalance__tasklistdrawer-table-cell-category">{{ tasklistitem.category }}</td>
                                <td data-testid="financialclose-project-trialbalance__tasklistdrawer-table-cell-remove">
                                    <v-icon class="ma-1" color="error" @click="removeRef(v)" data-testid="financialclose-project-trialbalance__tasklistdrawer-table-remove-btn">mdi-delete</v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <div v-else class="d-flex grey--text py-4 text-center " data-testid="financialclose-project-trialbalance__tasklistdrawer-empty-state">
                        <span class="font-size-lg">No task linked</span>
                    </div>


                </template>
                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <v-btn class="ml-2" color="primary"
                        @click="addUpdateGls(tasklistitem.reference_detail, tasklistitem._id)" data-testid="financialclose-project-trialbalance__tasklistdrawer-update-btn"><span>Update</span></v-btn>
                </template>

            </lb-drawer>

            <lb-drawer
                v-model="selectgldialog"
                heading="Select Task(s)"
                width="600"
                :loading="selectgldialogloading"
                data-testid="financialclose-project-trialbalance__selectgldrawer"
            >
                <template v-slot:body>
                    <div
                        class="trial-balance__select-gl-drawer"
                        data-testid="financialclose-project-trialbalance__selectgldrawer-body"
                    >
                        <p
                            class="trial-balance__select-gl-label trial-balance__select-gl-label--required"
                            data-testid="financialclose-project-trialbalance__selectgldrawer-label"
                        >
                            Tasklist
                        </p>
                        <SearchableMultiSelectDropdown
                            :value="selectgls"
                            :items="locationtaskList"
                            variant="field"
                            :show-chips="true"
                            placeholder="Select tasklist"
                            item-text="displayText"
                            item-value="_id"
                            search-placeholder="Search tasklist"
                            select-all-row-label="All tasks"
                            empty-message="No tasks available to select"
                            max-activator-width="100%"
                            :attach="false"
                            :use-fixed-menu-position="true"
                            menu-content-class="trial-balance__select-task-menu"
                            :disabled="selectgldialogloading"
                            data-testid-prefix="financialclose-project-trialbalance__selectgldrawer"
                            @input="selectgls = $event"
                        />
                    </div>
                </template>
                <template v-slot:actions>
                    <div class="trial-balance__select-gl-footer">
                        <span
                            class="trial-balance__select-gl-required"
                            data-testid="financialclose-project-trialbalance__selectgldrawer-required-label"
                        >
                            *Required
                        </span>
                        <v-spacer />
                        <v-btn
                            outlined
                            class="secondaryBtn text-none mr-2"
                            @click="selectgldialog = false"
                            data-testid="financialclose-project-trialbalance__selectgldrawer-cancel-btn"
                        >
                            <span>Cancel</span>
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="white--text text-none"
                            :disabled="!canAddSelectedTasks"
                            @click="addSelectedGls()"
                            data-testid="financialclose-project-trialbalance__selectgldrawer-add-btn"
                        >
                            <span>Add</span>
                        </v-btn>
                    </div>
                </template>
            </lb-drawer>

            <!-- Bulk Upload Component -->
            <BulkUpload
                ref="bulkUploadComponent"
                :upload-type="$options.BULK_CHECKLIST_UPLOAD_TYPE.TRIAL_BALANCE"
                test-id-prefix="trial-balance"
                :project="id"
                :existingTrialBalanceData="tb"
                :hideButton="true"
                @reload="refreshData"
            />

            <TaskDetailDrawer
                v-model="selectedTaskDetails"
                :loading="taskDetailLoading"
                :task="viewTaskDetails"
                :linked-tasks="listTask"
                :user-name-list="userNameList"
                :userid="userid"
                @select-task="viewTaskDetail"
            />

        <!-- Pagination -->
        <Pagination :list="filtereddata" :itemsperpage="itemsPerPage"
                            @paginated-data="setPaginatedData" data-testid="financialclose-project-trialbalance__pagination" />
    </div>
</template>

<script>
import './TrialBalance.scss';
import Pagination from '../../../components/Pagination/Pagination.vue';
import BulkUpload from '../../../components/BulkUpload/BulkUpload.vue';
import CustomizeColumnMenu from '../../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue';
import { SearchableMultiSelectDropdown } from '../../../components';
import ActivityLog from '../../../components/ActivityLog/ActivityLog.vue';
import TaskDetailDrawer from '../components/TaskDetailDrawer.vue';
import { mapGetters, mapActions } from 'vuex';
import { ACTIVITY_LOG_TYPES, BULK_CHECKLIST_UPLOAD_TYPE, TB_LOAD_MESSAGES, TASKLIST_LOAD_STATUS, TB_UPLOAD_MESSAGES } from '../../../utils/constants';
import TasklistLoadProgress from '../TaskList/components/TasklistLoadProgress/TasklistLoadProgress.vue';
import {
    TASK_LINKED_FILTER_FIELD,
    buildTaskLinkedFilterValues,
    normalizeTrialBalanceFilterCriteria,
} from './utils/TrialBalanceUtils';
import { tbUploadResultMessage } from '../../../utils/tbUpload';
let styledxlsx = require("sheetjs-style");
// This screen loads the full trial balance in the browser (old format) and is kept as a fallback. The paginated screen is TrialBalancePaginated.vue, selected by VUE_APP_FC_TB_PAGINATED.
export default {
    name: "financialclose_project_trialbalance",
    // Expose constants for template interpolation via $options
    ACTIVITY_LOG_TYPES,
    BULK_CHECKLIST_UPLOAD_TYPE,
    TB_LOAD_MESSAGES,
    TB_UPLOAD_MESSAGES,
    // props: ['props'],
    data: function () {
        return {
            right: "financialclose_project",
            // pbc: {},
            fileprocessing: {},
            fileprocessingpercent: {},
            userid: "",
            id: "",
            hasActiveTableFilter: false,
            tbtableheader: [
                { text: "GL Code", value: "glcode" },
                { text: "Tasklist Reference", value: "reference" },
                { text: "Type", value: "type" },
                { text: "Name", value: "name" },
                { text: "Opening Amount", value: "opening_amount", align: "right" },
                { text: "Transaction", value: "transaction", align: "right" },
                { text: "Audit Entries", value: "audit_entries", align: "right" },
                { text: "Closing Amount", value: "closing_amount", align: "right" },
                // { text: 'Action', value: 'action', align: "center", sortable: false },
            ],
            headers: [
                {
                    value: "indexno",
                    text: "SL No",
                    sortable: false,
                    filterable: false,
                    visible: true
                },
                {
                    value: "glcode",
                    text: "Account No.",
                    sortable: true,
                    filterable: true,
                    visible: true
                },
                {
                    value: "name",
                    text: "Account Name",
                    sortable: true,
                    filterable: true,
                    visible: true
                },
                {
                    value: "reference_detail",
                    text: "Tasklist Reference",
                    visible: true,
                    sortable: false,
                    filterable: true,
                    noTruncate: true,
                },
                {
                    value: "location",
                    text: 'Location',
                    filterable: true,
                    visible: true,
                    noTruncate: true,
                },
                {
                    value: "type",
                    text: "Type",
                    sortable: true,
                    filterable: true,
                    visible: true
                },
                {
                    value: "opening_amount",
                    text: "Opening Amount",
                    sortable: true,
                    filterable: true,
                    datatype: "number",
                    visible: true
                },
                {
                    value: "transaction",
                    text: "Transaction",
                    sortable: true,
                    filterable: true,
                    datatype: "number",
                    visible: true
                },
                {
                    value: "audit_entries",
                    text: "Journal Entries",
                    sortable: true,
                    filterable: true,
                    datatype: "number",
                    visible: true
                },
                {
                    value: "closing_amount",
                    text: "Closing Amount",
                    sortable: true,
                    filterable: true,
                    datatype: "number",
                    visible: true
                },
                
                {
                    value: "category",
                    text: "Category",
                    sortable: false,
                    lock: false,
                    visible: true,
                    filterable: true,
                },
                {
                    value: "subcategory",
                    text: "Sub Category",
                    sortable: false,
                    visible: true,
                    filterable: true,
                },
                {
                    value: "created_at",
                    text: "Created At",
                    sortable: false,
                    datatype: "date",
                    lock: false,
                    visible: true,
                    filterable: true,
                },
                {
                    value: "updated_at",
                    text: "Updated At",
                    sortable: false,
                    datatype: "date",
                    lock: false,
                    visible: true,
                    filterable: true,
                },
                {
                    value: "action",
                    text: "Action",
                    sortable: false,
                    datatype: "action",
                    visible: true
                },
            ],
            formatedData: [],
            formateDataCopy:[],
            dynamicFilteredData: null,
            tasklistdilog: false,
            tasklistdilogloading: false,
            tasklistitem: {},
            selectgldialog: false,
            selectgldialogloading: false,
            searchcustom: "",
            selectgls: [],
            selectRefIds: [],
            activitylogconfig: {
                trialbalanceupdated: {
                    icon: "mdi-pencil",
                    color: "primary",
                    displaytext: "Updated",
                },
                tbadd: {
                    icon: "mdi-table-plus",
                    color: "primary",
                    displaytext: "Trial Balance Added",
                },
            },
            selectchecklist_id: "",
            isFirst: false,
            itemsPerPage: 50,
            search: '',
            selectItem: [],
            selectedFilterItems: [],
            reUpload: false,
            UploadWithError: false,
            tableHeight: '',
            selectedTaskDetails: false,
            viewTaskDetails: null,
            taskDetailLoading: false,
            paginatedFilteredItems: [],
            listTask: [],
            showSearch:false,
            searchQuery:"",
            searchcolumn:"",
            toggleSearchBtn:false,
            customizeMenuOpen: false,
            activeFilterCriteria: null,
            sawTbUploadInProgress: false,
        };
    },
    components: {
        BulkUpload,
        Pagination,
        CustomizeColumnMenu,
        SearchableMultiSelectDropdown,
        ActivityLog,
        TaskDetailDrawer,
        TasklistLoadProgress,
    },
    created() {
        this.tableHeight = window.innerHeight - 400;
        // Update location header text from store
        const locationHeader = this.headers.find(h => h.value === 'location');
        if (locationHeader && this.$store?.state?.LocationHeader) {
            locationHeader.text = this.$store.state.LocationHeader;
        }
        this.refreshData();
        
    },
    activated() {
        this.refreshData();
    },
    deactivated() {
        this.cancelTbLoadAction();
    },
    beforeDestroy() {
        this.sawTbUploadInProgress = false;
        this.stopTbUploadPollingAction();
        this.advanceTbUploadEpochAction();
        this.cancelTbLoadAction();
    },

    methods: {
        ...mapActions('trialBalance', {
            fetchDetailsAction: 'fetchDetails',
            fetchLastUpdatedAtAction: 'fetchLastUpdatedAt',
            syncERPAction: 'syncERP',
            fetchLocationTasklistAction: 'fetchLocationTasklist',
            editTrialBalanceAction: 'editTrialBalance',
            fetchTaskAction: 'fetchTask',
            retryTbPagesAction: 'retryTbPages',
            cancelTbLoadAction: 'cancelTbLoad',
            startTbUploadPollingAction: 'startTbUploadPolling',
            stopTbUploadPollingAction: 'stopTbUploadPolling',
            advanceTbUploadEpochAction: 'advanceTbUploadEpoch',
        }),
        async retryTbLoad() {
            if (this.tbLoad.retrying) return;
            try {
                await this.retryTbPagesAction({ id: this.id });
            } catch (err) {
                this.$store.commit('sbError', err?.message || TB_LOAD_MESSAGES.PAGE_FAILED);
            }
        },
        /**
         * Handler for filter-active-change event from DataTableAction
         */
        onFilterActiveChange(isActive) {
            this.hasActiveTableFilter = isActive;
        },
        /**
         * Clear table filters via DataTableAction ref
         */
        clearTableFilter() {
            if (this.$refs.dataTableAction) {
                this.$refs.dataTableAction.clearFilter();
            }
        },
        async syncERP() {
            await this.syncERPAction({
                id: this.id,
                startDate: this.metadata.from,
                endDate: this.metadata.to,
            });
        },
        // --- ERP TB Pipeline Status Helpers ---
        async fetchLastUpdatedAt() {
            await this.fetchLastUpdatedAtAction({
                id: this.id,
                startDate: this.$nova.formatDate(this.metadata.from),
                endDate: this.$nova.formatDate(this.metadata.to),
            });
        },
        toggleSearch() {
            this.toggleSearchBtn = !this.toggleSearchBtn; // Toggle search box visibility
        },
        filterPart(item, options = {}) {
            this.activeFilterCriteria = item;
            const stored = Array.isArray(this.formateDataCopy) ? this.formateDataCopy : [];
            const criteriaNeedsLocation = item && Object.prototype.hasOwnProperty.call(item, 'location');
            const sourceData = criteriaNeedsLocation
                ? stored.map((row) => this.withVisibleLocation(row))
                : stored;
            const criteria = normalizeTrialBalanceFilterCriteria(item);
            const filtered = this.$nova.filterByDynamicCriteria(sourceData, criteria);
            this.dynamicFilteredData = Array.isArray(filtered) ? filtered.slice() : [];
            if (options.keepPage) return;
            const firstPage = this.filtereddata.slice(0, this.itemsPerPage);
            this.setPaginatedData(firstPage);
        },
        locationNamesFor(locationId) {
            const map = this.locationNameById || {};
            const ids = Array.isArray(locationId)
                ? locationId
                : (locationId != null && locationId !== '' ? [locationId] : []);
            const names = [];
            ids.forEach((id) => {
                if (id == null || id === '') return;
                const key = typeof id === 'object' && id._id != null ? String(id._id) : String(id);
                const name = map[key];
                if (name) names.push(name);
            });
            return names;
        },
        withVisibleLocation(row) {
            if (!row) return row;
            return {
                ...row,
                location: this.locationNamesFor(row.location_id),
            };
        },
        setPaginatedData(paginationInfo) {
            const rows = paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo
                ? (paginationInfo.data || [])
                : (paginationInfo || []);
            if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
                this.page = paginationInfo.page || 1;
            }
            this.paginatedFilteredItems = rows.map((row) => this.withVisibleLocation(row));
        },
        downloadExcel() {
          if (!this.tbLoadComplete) return;
          try {
      const visibleHeaders = this.headers.filter(h => h.visible && h.value !== 'action');
      // Title / meta rows
      const dt = [
        [undefined],
        [undefined, { v: 'Trial Balance', s: { font: { bold: true, sz: 20 } } }],
        [undefined, { v: this.metadata.description || this.metadata.name || '', s: { font: { bold: true, sz: 14 } } }],
      ];
      if (this.metadata.from || this.metadata.to) {
        const rangeText = `${this.metadata.from ? this.$nova.formatDate(this.metadata.from) : ''}${
          this.metadata.to ? ' - ' + this.$nova.formatDate(this.metadata.to) : ''
        }`;
        if (rangeText.trim()) {
          dt.push([undefined, { v: rangeText, s: { font: { bold: true, sz: 14 } } }]);
        }
      }
      dt.push([undefined]);
      // Header row
      dt.push([
        undefined,
        ...visibleHeaders.map(h => ({ v: h.text, s: { font: { bold: true } } })),
      ]);

      const unformatNumber = (val) => {
        if (val === undefined || val === null || val === '') return '';
        if (typeof val === 'number') return val;
        const num = Number(String(val).replace(/,/g, ''));
        return isNaN(num) ? '' : num;
      };

      // Data rows
      for (const row of this.formateDataCopy) {
        const dataRow = [undefined];
        visibleHeaders.forEach(h => {
          let value = row[h.value];

            // Special transforms
            if (h.value === 'reference_detail' && Array.isArray(value)) {
              value = value.map(r => r.ref || r.description || '').filter(Boolean).join(', ');
            } else if (h.value === 'location') {
              value = this.locationNamesFor(row.location_id).join(', ');
            }

            if (h.datatype === 'number') {
              const num = unformatNumber(value);
              dataRow.push(
                num === '' ? '' : { v: num, t: 'n', z: '#,##' }
              );
            } else if (h.datatype === 'date') {
              if (value) {
                const d = new Date(value);
                if (!isNaN(d.getTime())) {
                  dataRow.push({ v: d, t: 'd', z: 'dd-mmm-yyyy' });
                } else {
                  dataRow.push(value);
                }
              } else {
                dataRow.push('');
              }
            } else {
              dataRow.push(value === undefined || value === null ? '' : value);
            }
        });
        dt.push(dataRow);
      }

      const worksheet = styledxlsx.utils.aoa_to_sheet(dt);

      // Optional: widen columns a bit
      const colWidths = visibleHeaders.map(h => {
        // simple heuristic: header length + a little padding
        const base = (h.text || '').length;
        return { wch: Math.min(Math.max(base + 4, 12), 40) };
      });
      // First leading undefined column
      worksheet['!cols'] = [{ wch: 3 }, ...colWidths];

      const workbook = styledxlsx.utils.book_new();
      styledxlsx.utils.book_append_sheet(workbook, worksheet, 'Trial Balance');

      const fname =
        'Trial Balance - ' +
        (this.metadata.name || this.metadata.description || 'Export')
          .replace(/\s+/g, '-')
          .substring(0, 120) +
        '.xlsx';
      styledxlsx.writeFile(workbook, fname);
    } catch (err) {
            this.$store.commit('sbError', err?.message || err || 'Unknown error!');
            console.error(err);
          }
        },
        
        formatTbRow(item, index) {
            return {
                _id: item._id,
                __key: index,
                __formatedkey: index,
                indexno: index + 1,
                reference_detail: item.reference_detail || [],
                [TASK_LINKED_FILTER_FIELD]: buildTaskLinkedFilterValues(item.reference_detail || []),
                glcode: item.glcode,
                type: item.type,
                name: item.name,
                location_id: item.location,
                location: this.locationNamesFor(item.location),
                category: item.category,
                subcategory: item.subcategory,
                opening_amount: this.formatNum((item.opening_amount || 0).toFixed(0)),
                transaction: this.formatNum((item.transaction || 0).toFixed(0)),
                audit_entries: this.formatNum((item.audit_entries || 0).toFixed(0)),
                closing_amount: this.formatNum((item.closing_amount || 0).toFixed(0)),
                created_at: item.created_at,
                updated_at: item.updated_at,
            };
        },
        syncFormattedRows(rows) {
            const list = Array.isArray(rows) ? rows : [];
            if (list.length < this.formateDataCopy.length) {
                this.formateDataCopy = list.map((item, index) => this.formatTbRow(item, index));
            } else if (list.length > this.formateDataCopy.length) {
                for (let i = this.formateDataCopy.length; i < list.length; i += 1) {
                    this.formateDataCopy.push(this.formatTbRow(list[i], i));
                }
            } else {
                return;
            }
            this.formatedData = this.formateDataCopy;
            if (this.hasActiveTableFilter && this.activeFilterCriteria) {
                this.filterPart(this.activeFilterCriteria, { keepPage: true });
                return;
            }
            this.dynamicFilteredData = this.formateDataCopy.slice();
        },
        refreshData() {
            this.id = this.$route.params.id || "";
            this.userid = this.$store.state.user.id;
            this.getData();
            this.fetchLastUpdatedAt();
        },
        clearFormattedTrialBalanceData() {
            this.formatedData = [];
            this.formateDataCopy = [];
            this.dynamicFilteredData = [];
            this.setPaginatedData([]);
        },
        async getData() {
            this.clearFormattedTrialBalanceData();
            this.activeFilterCriteria = null;
            try {
                const fetchSucceeded = await this.fetchDetailsAction({ id: this.id });
                if (fetchSucceeded === false) {
                    return;
                }
                if (!Array.isArray(this.tb)) {
                    console.error('[TrialBalance]: fetchDetailsAction did not return a valid trial balance list');
                }
                if (this.uploadInProgress) {
                    this.sawTbUploadInProgress = true;
                    this.startTbUploadPollingAction({ id: this.id });
                }
            } catch (err) {
                this.clearFormattedTrialBalanceData();
                this.$store.commit('sbError', err?.message || err || 'Unknown error!');
                console.error('[TrialBalance]: getData error', err);
            }
        },
        addEditForm(item) {
            this.tasklistitem = { ...item };
            this.tasklistdilog = true;
        },
        async openSelectGlDialog(selectitem, location) {
            this.selectgldialog = true;
            this.selectgldialogloading = true;
            const locationid = Array.isArray(location) && location.length > 0
                ? location[0]
                : (location || 'axyz');
            try {
                await this.fetchLocationTasklistAction({ id: this.id, locationid });
                this.selectgls = selectitem.map(item => item._id);
            } finally {
                this.selectgldialogloading = false;
                this.selectgldialog = true;
            }
        },
        addSelectedGls() {
            this.tasklistitem.reference_detail = [];
            const filteredItems = this.locationtaskList.filter(item => this.selectgls.includes(item._id));
            // let selectarr = [];
            for (let item of filteredItems) {
                let selectObj = { ref: item.ref, description: item.description, _id: item._id };
                this.selectRefIds.push(item._id);
                this.tasklistitem.reference_detail.push(selectObj);
            }
            //this.tasklistitem.reference_detail = selectarr;
            this.selectgldialog = false;

        },
        async addUpdateGls(gllist, trialid) {
            const gllistldetails = gllist.map(list => list._id);
            this.tasklistdilogloading = true;
            try {
                const success = await this.editTrialBalanceAction({
                    projectId: this.id,
                    trialId: trialid,
                    data: { reference: gllistldetails },
                });
                if (success) {
                    this.tasklistdilog = false;
                    this.refreshData();
                }
            } finally {
                this.tasklistdilogloading = false;
            }
        },
        removeRef(item) {
            let indexItem = this.tasklistitem.reference_detail.indexOf(item);
            this.tasklistitem.reference_detail.splice(indexItem, 1);
            for (const item of this.tasklistitem.reference_detail || []) {
                this.selectRefIds.push(item._id);
            }
        },
        openTaskDetail(task) {
            this.listTask = Array.isArray(task) ? task : [];
            this.viewTaskDetail(this.listTask[0]);
            this.selectedTaskDetails = true;
        },
        async viewTaskDetail(task) {
            if (!task || !task._id) return;
            this.taskDetailLoading = true;
            this.viewTaskDetails = null;
            try {
                const enrichedTask = await this.fetchTaskAction({
                    projectId: this.id,
                    taskId: task._id,
                });
                // Map __computed fields to top-level for template compatibility
                const computed = enrichedTask.__computed || {};
                this.viewTaskDetails = {
                    ...enrichedTask,
                    __tbtotals: computed.tbtotals || { total: 0, items: [] },
                    threshold: computed.threshold ?? 'NA',
                    locationName: computed.locationName || '',
                };
            } catch (err) {
                this.$store.commit('sbError', err?.message || 'Failed to fetch task details');
                this.viewTaskDetails = null;
            } finally {
                this.taskDetailLoading = false;
            }
        },

        addTableHeader(item) {
          this.headers.find((x) => x === item ? x.visible = !x.visible : "")
        },
        /**
         * Handle Apply button click from CustomizeColumnMenu
         * Updates column visibility locally (session only)
         * @param {Array} headers - Updated headers array
         */
        handleApplyColumns(headers) {
            this.headers = headers;
            this.customizeMenuOpen = false;
        },
        formatNum(input) {
            let number = Number(input);
            if (isNaN(number) || input === null || input === undefined || input === "") {
                return "";
            }
            return number.toLocaleString("en-US");
        },
        openBulkUpload() {
            if (this.$refs.bulkUploadComponent) {
                this.$refs.bulkUploadComponent.openBulkUpload();
            }
        },

        notifyTbUploadFinished() {
            const result = tbUploadResultMessage(this.tbUpload);
            if (result.error) {
                this.$store.commit('sbError', result.message || TB_UPLOAD_MESSAGES.FAILED);
                return;
            }
            this.$store.commit('sbSuccess', result.message || TB_UPLOAD_MESSAGES.COMPLETED);
            console.log('[TrialBalance]:', { tbUpload: 'completed' });
        }

    },
    computed: {
        ...mapGetters('trialBalance', [
            'metadata',
            'tb',
            'checklist',
            'reflist',
            'summary',
            'pbcdata',
            'formdata',
            'userlist',
            'userNameList',
            'lastRunData',
            'erpRunningStatus',
            'locationtaskList',
            'loading',
            'locationNameById',
            'tbLoad',
            'tbUpload',
        ]),
        tbLoadComplete() {
            return this.tbLoad.status === TASKLIST_LOAD_STATUS.COMPLETE;
        },
        tbHeaderLoadProgress() {
            const load = this.tbLoad;
            if (!load || String(load.cycleId || '') !== String(this.id || '')) return null;
            const failed = load.status === TASKLIST_LOAD_STATUS.ERROR;
            // A failed first request clears metadata and leaves total at 0. Still show Retry.
            if (!failed && !this.metadata?._id) return null;
            return {
                loaded: load.loaded,
                total: load.total,
                status: load.status,
                error: load.error || '',
                retrying: !!load.retrying,
            };
        },
        closingbalancetotal() {
          return this.metadata?.totalClosingBalance || 0;
        },
        canAddSelectedTasks() {
          return Array.isArray(this.selectgls) && this.selectgls.length > 0;
        },
        groupedItems() {
            const grouped = {};
            this.checklist.forEach(item => {
                if (!grouped[item.category]) {
                    grouped[item.category] = [];
                }
                grouped[item.category].push(item);
            });
            return grouped;
        },
        columnFilterSourceData() {
            return (this.formateDataCopy || []).map((row) => ({
                ...row,
                location: this.locationNamesFor(row.location_id),
                reference_detail: Array.isArray(row[TASK_LINKED_FILTER_FIELD])
                    ? row[TASK_LINKED_FILTER_FIELD]
                    : (row.reference_detail || []).map((entry) => entry && entry.ref),
            }));
        },
        filtereddata(){
            const baseList = Array.isArray(this.dynamicFilteredData) ? this.dynamicFilteredData : this.formatedData;
            if (!this.searchQuery.trim()) {
                return baseList;
            }
            const searchTerm = this.searchQuery.trim().toLowerCase();
            return baseList.filter(item =>
                String(item.name || '').toLowerCase().includes(searchTerm)
            );
        },
        uploadInProgress() {
            return !!(this.tbUpload && this.tbUpload.inProgress);
        },
    },
    watch: {
        tb(rows) {
            this.syncFormattedRows(rows);
        },
        '$route.params.id'(id, previousId) {
            if (!id || String(id) === String(previousId)) return;
            this.sawTbUploadInProgress = false;
            this.stopTbUploadPollingAction();
            this.advanceTbUploadEpochAction();
        },
        uploadInProgress(inProgress, wasInProgress) {
            if (inProgress) {
                this.sawTbUploadInProgress = true;
                this.startTbUploadPollingAction({ id: this.id });
                return;
            }
            this.stopTbUploadPollingAction();
            if (!wasInProgress || !this.sawTbUploadInProgress) return;
            this.sawTbUploadInProgress = false;
            this.notifyTbUploadFinished();
            this.refreshData();
        },
    },
};
</script>

<style scoped>
.d-cont{
  display: contents !important;
}
.border-red {
  border: 1px solid #F3B9BA !important;
  border-right: 1px solid #F3B9BA !important;
  border-bottom: 1px solid #F3B9BA !important;
  border-top: 1px solid #F3B9BA !important;
  border-left: 1px solid #F3B9BA !important;
}
</style>